/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Failed_To_Extract_Audio_From_Source_VideoInputs */



/**
* | output |
* | --- |
* | "Failed to extract audio from source video. {error}" |
*
* @param {Failed_To_Extract_Audio_From_Source_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_extract_audio_from_source_video = /** @type {((inputs: Failed_To_Extract_Audio_From_Source_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Extract_Audio_From_Source_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’extraction audio de la vidéo source. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audioextraktion aus dem Quellvideo fehlgeschlagen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile estrarre l'audio dal video sorgente. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось извлечь звук из исходного видео. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo extraer el audio del vídeo de origen. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法从源视频中提取音频。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ソースビデオからオーディオを抽出できませんでした。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्रोत वीडियो से ऑडियो निकालने में विफल। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao extrair o áudio do vídeo de origem. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to extract audio from source video. ${i?.error}`)
});